import fevaDisclosureViewTemplate from "./FevaDisclosureViewTemplate";

const FevaDisclosureDirective = function ($injector) {
    const logger = $injector.get("$log").getInstance("FevaDisclosureDirective");
    logger.debug("Directive loaded");

    return {
        restrict: "E",
        replace: "true",
        template: fevaDisclosureViewTemplate,
        scope: {
            isSubjectToFeva: "="
        }
    };
};

FevaDisclosureDirective.$inject = ["$injector"];
export default FevaDisclosureDirective;
